import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VxeUIPluginRenderElement from '@vxe-ui/plugin-render-element'
import '@vxe-ui/plugin-render-element/dist/style.css'
import BaaS from 'minapp-sdk';
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.use(ElementUI);
VxeUIAll.use(VxeUIPluginRenderElement)
Vue.use(VxeUIAll);
Vue.use(VxeUITable)

BaaS.init('e50532c6051f2e5a5313')

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
